import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addStatementOfAccount = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Process Statement Of Accounts',
    body
  );
  return data;
});

export const updateStatementOfAccount = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.post(
    `/api/resource/Process Statement Of Accounts/${id}`,
    body
  );
  return data;
});

export const getStatementOfAccount = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Process Statement Of Accounts?fields=["name","company","from_date","to_date"]'
  );
  return data;
});
export const getStatementOfAccountById = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Process Statement Of Accounts/${id}`
  );
  return data;
});
export const getStatementOfAccountPdf = catchAsync(async (name) => {
  const data = await axiosInstance.get(
    `/api/method/technoerp.services.print_soa_pdf?name=${name}`,
    { responseType: 'blob' }
  );
  return data;
});

export const deleteStatementOfAccount = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Process Statement Of Accounts/${record}`
  );
  return data;
});
